import React, { PureComponent } from "react";
import { Field, reduxForm, SubmissionError } from "redux-form";
import CheckBox from "../../inputs/CheckBox";
import TextInput from "../../inputs/TextInput";
import { Button } from "../../util/Clickable";
import * as normalize from "../../util/Normalizer";
import { IntlText } from "../../util/Text";
import * as validate from "../../util/Validator";

class ProfileForm extends PureComponent {
  state = {
    loading: false,
  };

  onSubmit = (values) => {
    this.setState({
      loading: true,
    });
    return this.props.onSubmit(values).then(({ value, action }) => {
      if (value.status < 300) {
        this.setState(
          {
            loading: false,
          },
          () => {
            this.props.onSuccess &&
              this.props.onSuccess(value.data, value.response);
          },
        );
      } else {
        this.setState({
          loading: false,
        });
        const errors = Object.keys(value.errors).reduce((dic, key) => {
          dic[key] = Array.isArray(value.errors[key])
            ? value.errors[key].join("\n")
            : null;
          return dic;
        }, {});
        throw new SubmissionError(errors);
      }
    });
  };

  render = () => {
    return (
      <form
        onSubmit={this.props.handleSubmit(this.onSubmit)}
        action={this.props.action}
        method="post"
      >
        <div className="uk-margin-small uk-grid-small" data-uk-grid>
          <div className="uk-width-1-2@s">
            <Field
              name="name"
              component={TextInput}
              labelId="forms.attr.name"
              validate={[validate.required]}
              required
            />
          </div>
        </div>

        <div className="uk-margin-small uk-grid-small" data-uk-grid>
          <div className="uk-width-small">
            <Field
              name="country"
              component={TextInput}
              labelId="forms.attr.country"
            />
          </div>
          <div className="uk-width-expand">
            <Field
              name="address"
              component={TextInput}
              labelId="forms.attr.address"
            />
          </div>
        </div>

        <div className="uk-margin-small uk-grid-small" data-uk-grid>
          <div className="uk-width-1-2@s">
            <Field
              name="tel"
              type="tel"
              component={TextInput}
              labelId="forms.attr.tel"
              validate={[validate.tel]}
              normalize={normalize.numberOnly}
            />
          </div>
          <div className="uk-width-1-2@s">
            {/*<Field 
                           name="primary_lang" component={Select} labelId="forms.attr.primary_lang"
                           options={languages} notNull
                         />*/}
          </div>
        </div>

        <div className="uk-margin-small">
          <Field
            name="opted_out"
            component={CheckBox}
            labelId="forms.attr.opted_out"
          />
        </div>

        {(() => {
          if (this.props.error) {
            return (
              <div className="uk-margin-small uk-text-danger uk-text-center@s">
                <span>{this.props.error}</span>
              </div>
            );
          }
        })()}
        <div className="uk-margin uk-text-center">
          <Button
            className="uk-button uk-button-default"
            type="submit"
            disabled={this.props.invalid}
            ga={{ category: this.props.form, action: "submit" }}
            loading={this.state.loading ? 1 : 0}
          >
            <IntlText id="forms.submit" />
          </Button>
        </div>
      </form>
    );
  };
}

export default reduxForm({
  form: "collector-profile-form",
  enableReinitialize: true,
})(ProfileForm);
